<template>
    <auth-layout pageClass="login-page">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-4 col-md-6 col-sm-8">
                <form action="#" @submit.prevent="login">
                    <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
                    <fade-render-transition>
                        <card>
                            <div slot="header">
                                <h3 class="card-title text-center">Login</h3>
                            </div>
                            <div>
                                <fg-input label="Email"
                                          placeholder="Votre email"
                                          type="email"
                                          v-model="username">

                                </fg-input>
                                <fg-input label="Mot de passe"
                                          type="password"
                                          placeholder="Mot de passe"
                                          v-model="password">
                                </fg-input>
                            </div>
                            <div class="text-center">

                                <button type="submit" class="btn btn-fill btn-info btn-round btn-wd ">Me connecter
                                </button>

                                <!--<br><div class="forgot">
                                  <router-link to="/register" class="card-category">
                                    Forgot your password?
                                  </router-link>
                                </div>-->
                            </div>
                        </card>
                    </fade-render-transition>

                </form>
            </div>
        </div>
    </auth-layout>
</template>
<script>
    import {FadeRenderTransition} from 'src/components/index'
    import AuthLayout from './AuthLayout.vue'

    export default {
        components: {
            FadeRenderTransition,
            AuthLayout
        },
        data() {
            return {
                username: '',
                password: '',
            }
        },
        methods: {
            login() {
                this.$store.dispatch('retrieveToken', {
                    username: this.username,
                    password: this.password,
                })
                    .then(response => {

                        if (response.status == '200' && response.data != "Your credential are incorrect. Please try again.") {

                            const user = response.data;
                            const token = user.access_token

                            this.$store.commit('setToken', token)
                            this.$store.commit('setUser', user)

                            window.location.reload()

                        }else{
                            this.$message({
                                message: 'Utilisateur ou mot de passe incorrect',
                                type: 'error',
                                center: true
                            });
                        }
                    }, (error) =>{

                        this.$message({
                            message: 'Une erreur est survenue. Merci de relancer la page. Si le problème persiste, voir avec le pole WEB',
                            type: 'error',
                            center: true
                        });
                    })


            },

            toggleNavbar() {
                document.body.classList.toggle('nav-open')
            },

            closeMenu() {
                document.body.classList.remove('nav-open')
                document.body.classList.remove('off-canvas-sidebar')
            }
        },
        beforeDestroy() {
            this.closeMenu()
        }
    }
</script>
<style>
    .navbar-nav .nav-item p {
        line-height: inherit;
        margin-left: 5px;
    }
</style>
